import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Modal, Col, Row, Alert } from 'react-bootstrap';
import Select from 'react-select';
import Spinner from '../../utils/Spinner';
import MonitorUrlCrudService from '../../../services/MonitorUrlCrudService';
import InputText from '../../../components/Forms/InputText';

export default function ModalUrls({ show, handleClose, dataItem, setRenderRows }) {
  const isViewOrDelete = dataItem.typeView === 'View' || dataItem.typeView === 'Delete';

  const urlFields = {
    name: '',
    url: '',
    priorityLevel: 1,
    type: 'External',
    client_id: 0
  };

  const searchClientTextHandler = useRef(null);
  const [formValues, setFormValues] = useState(urlFields);
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [enableSaveChanges, setEnableSaveChanges] = useState(true);
  const [searchClient, setSearchClient] = useState('');
  const [clientOptions, setClientOptions] = useState([]);
  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }

  useEffect(() => {
    const delaySearch = setTimeout(async () => {
      if (!searchClientTextHandler.current) return;
      const newValue = searchClientTextHandler.current;

      if (!newValue) return;

      setIsLoading(true);

      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + setRenderRows
        }
      };

      try {
        const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + '/clients/searchForAutocomplete?page=1&perPage=20&filterBy=name&filterValue=*' + newValue + '*', requestOptions);
        const data = await response.json();
        setIsLoading(false);

        if (data.data) {
          const clientOptions = data.data.map(client => ({
            label: client.name,
            value: client.id,
            url: client.path,
            id: client._id
          }));
          setClientOptions(clientOptions);
        }
      } catch (error) {
        console.error('Error fetching client suggestions:', error);
        setIsLoading(false);
      }
    }, 1500);

    return () => clearTimeout(delaySearch);
  }, [searchClientTextHandler.current]);

  useEffect(() => {
    if (show && dataItem.codeItem > 0) {
      MonitorUrlCrudService.getUrlById(dataItem.codeItem).then(async res => {
        let currentMethod = res.data.data[0];
        setFormValues(currentMethod);
      });
    } else {
      setFormValues(urlFields);
      setEnableSaveChanges(true);
      setSuccessMessage(null);
      setIsLoading(false);
      setClientOptions([]);
      setSearchClient('');
    }
  }, [dataItem, show]);

  const formFieldsHandler = (event) => {
    switch (event.target.name) {
      case 'Name': setFormValues({ ...formValues, name: event.target.value }); break;
      case 'Url': setFormValues({ ...formValues, url: event.target.value }); break;
      case 'priorityLevel': setFormValues({ ...formValues, priorityLevel: parseInt(event.target.value) }); break;
      case 'type': setFormValues({ ...formValues, type: event.target.value }); break;
      default: break;
    }
    setEnableSaveChanges(false);
  };


  const handleChange = (newValue) => {
    setSearchClient(newValue);
    searchClientTextHandler.current = newValue;
  };

  const handleClientSelect = (selectedOption) => {
    if (!selectedOption) {
      setClientOptions([]);
      setSearchClient('');
      setFormValues(urlFields);
      setEnableSaveChanges(true);
      return;
    }

    setSearchClient(selectedOption.label);
    setFormValues({ ...formValues, name: selectedOption.label, url: selectedOption.url, type: 'Internal', client_id: selectedOption.id });
    setEnableSaveChanges(false);
  };

  const handleDelete = async () => {
    setIsLoading(true);
    MonitorUrlCrudService.deleteUrl(dataItem.codeItem).then(res => {
      setSuccessMessage('success');
      sleep(1500).then(() => {
        setIsLoading(false);
        handleClose();
        window.location.href = '/MonitorUrls';
      })
    }).catch(err => {
      console.error('Error trying delete URL: ', err);
      if (err.response.status !== 200) {
        setSuccessMessage('danger');
      }
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const { name, url, priorityLevel, type } = formValues;
    const updateMethod = { name, url, priorityLevel, type };
    let serviceFunction = null;

    if (!dataItem.codeItem && dataItem.typeView === 'Create') {
      if (formValues.type == 'Internal') updateMethod.client_id = formValues.client_id;

      serviceFunction = MonitorUrlCrudService.createUrl;
    } else {
      serviceFunction = MonitorUrlCrudService.updateUrl;
    }

    try {
      await serviceFunction(updateMethod, dataItem.codeItem);
      setSuccessMessage('success');
      await sleep(1500);
      setIsLoading(false);
      handleClose();
      window.location.href = '/MonitorUrls';
    } catch (err) {
      console.error('Error trying to send URL: ', err);
      setSuccessMessage('danger');
      setEnableSaveChanges(true);
      setIsLoading(false);
    }
  };

  let submitButton = !isViewOrDelete && (
    <Button type="button" disabled={enableSaveChanges} onClick={handleSubmit}>
      Save Changes
    </Button>
  );
  if (dataItem.typeView === 'Delete') {
    submitButton = (<><Button type="button" variant="danger" onClick={() => handleDelete()} >Delete</Button> {'  '}  {'  '} </>);
  }

  return (<>
    <Modal show={show} onHide={handleClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title> {dataItem.typeView} {dataItem.nameView} Code {dataItem.codeItem} </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {(dataItem.typeView === 'Delete') ? (<Alert key='danger' variant='danger'> ¿Seguro de Eliminar esta Url? </Alert>) : ""}

        {(dataItem.typeView === 'Create') ? (
          <Row className="mb-3">
            <Form.Group as={Col} md={50} key={'searchClient'}>
              <Form.Label>Buscar y seleccionar Cliente</Form.Label>
              <Select
                inputValue={searchClient}
                options={clientOptions}
                onChange={handleClientSelect}
                onInputChange={handleChange}
                isDisabled={isViewOrDelete}
                isClearable
                placeholder="Nombre del Cliente"
              />
            </Form.Group>
          </Row>
        ) : ""}

        <Row className="mb-3">
          <InputText defaultValue={formValues.name} label={'Name'} handler={formFieldsHandler} conditionView={formValues.type == 'Internal' ? true : isViewOrDelete} width={'12'} />
        </Row>
        <Row className="mb-3">
          <InputText defaultValue={formValues.url} label={'Url'} handler={formFieldsHandler} conditionView={formValues.type == 'Internal' ? true : isViewOrDelete} width={'12'} />
        </Row>

        <Row className="mb-3">
          <Form.Group as={Col} md="4" key="priorityLevel">
            <Form.Label>priorityLevel</Form.Label>
            <Form.Select name="priorityLevel" onChange={formFieldsHandler} readOnly={isViewOrDelete} disabled={isViewOrDelete} value={formValues.priorityLevel}>
              {['Media', 'Alta', 'Muy Alta'].map((label, index) => (
                <option key={index} value={index + 1}>{label}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group as={Col} md="4" key="type">
            <Form.Label>type</Form.Label>
            <Form.Select name="type" readOnly={true} disabled={true} value={formValues.type}>
              {['External', 'Internal'].map(type => <option key={type} value={type}>{type}</option>)}
            </Form.Select>
          </Form.Group>
        </Row>

        {isLoading ? <Spinner /> : null}
        {submitButton} {'  '}{'  '}
        <Button variant="secondary" onClick={handleClose}> Close </Button>

        {successMessage === 'danger' && (
          <Alert key="danger" variant="danger">
            Error al Crear o Actualizar URL!
          </Alert>
        )}
        {successMessage === 'success' && (
          <Alert key="success" variant="success">
            URL Actualizada!
          </Alert>
        )}
      </Modal.Body>
    </Modal>
  </>)
}